const getProductMedia = (serverMedia) => {
  const images = serverMedia.images.map(
    ({ url, label, dimensions: { __typename, ...dimensionsRest } }) => ({
      url,
      label: label ?? void 0,
      dimensions: dimensionsRest
    })
  );
  return {
    images
  };
};
export {
  getProductMedia
};
//# sourceMappingURL=get-product-media.js.map
